import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type PartsDetailTemplate = {
  showBreadcrumb: boolean;
  backLinkLabel: string;
  showWarehouseAvailability: boolean;
  showMarketingDescription: boolean;
  showVendorMeta: boolean;
  showDimensions: boolean;
  primaryCtaLabel: string;
  primaryCtaUrl: string; // tokens: {id} {slug}
  primaryCtaEnabled: boolean;
  headerHtml: string;
  footerHtml: string;
};

export const DEFAULT_PARTS_DETAIL_TEMPLATE: PartsDetailTemplate = {
  showBreadcrumb: true,
  backLinkLabel: "Back to catalog",
  showWarehouseAvailability: true,
  showMarketingDescription: true,
  showVendorMeta: true,
  showDimensions: true,
  primaryCtaLabel: "Request This Part",
  primaryCtaUrl: "/parts/request?product={id}",
  primaryCtaEnabled: true,
  headerHtml: "",
  footerHtml: "",
};

export const PARTS_DETAIL_TEMPLATE_KEY = "parts_detail_template";

export function usePartsDetailTemplate() {
  return useQuery({
    queryKey: ["site-settings", PARTS_DETAIL_TEMPLATE_KEY],
    queryFn: async (): Promise<PartsDetailTemplate> => {
      const { data } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", PARTS_DETAIL_TEMPLATE_KEY)
        .maybeSingle();
      const v = (data?.value as Partial<PartsDetailTemplate>) || {};
      return { ...DEFAULT_PARTS_DETAIL_TEMPLATE, ...v };
    },
    staleTime: 5 * 60 * 1000,
  });
}
